// extracted by css-extract-rspack-plugin
export default {"wrapper":"R3_tEi","visible":"Tp6jH4","close-button":"XzVjXK","closeButton":"XzVjXK"};